(function(){
  function ready(fn){if(document.readyState!=='loading')fn();else document.addEventListener('DOMContentLoaded',fn)}
  ready(function(){
    document.documentElement.classList.add('fa-js','hw-js');

    var reveal=document.querySelectorAll('[data-fa-reveal]');
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('fa-visible');io.unobserve(entry.target)}})},{threshold:.12});
      reveal.forEach(function(el,i){el.style.transitionDelay=Math.min(i%8,5)*55+'ms';io.observe(el)});
    }else{reveal.forEach(function(el){el.classList.add('fa-visible')})}

    var reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var finePointer=window.matchMedia('(hover:hover) and (pointer:fine)').matches;

    if(finePointer&&!reduceMotion){
      document.querySelectorAll('.fa-magnetic').forEach(function(el){
        el.addEventListener('mousemove',function(e){
          var r=el.getBoundingClientRect(), x=e.clientX-r.left-r.width/2, y=e.clientY-r.top-r.height/2;
          el.style.transform='translate('+x*.16+'px,'+y*.2+'px) translateY(-5px)';
        });
        el.addEventListener('mouseleave',function(){el.style.transform='translate(0,0)'});
      });

      document.querySelectorAll('.fa-tilt-card').forEach(function(card){
        card.style.position=card.style.position||'relative';
        var spider=document.createElement('span');spider.className='hw-hover-spider';spider.setAttribute('aria-hidden','true');spider.textContent='🕷';card.appendChild(spider);
        card.addEventListener('mousemove',function(e){
          var r=card.getBoundingClientRect(), px=(e.clientX-r.left)/r.width-.5, py=(e.clientY-r.top)/r.height-.5;
          card.style.transform='perspective(950px) rotateX('+(-py*7)+'deg) rotateY('+(px*8)+'deg) translateY(-10px)';
        });
        card.addEventListener('mouseleave',function(){card.style.transform='perspective(950px) rotateX(0) rotateY(0) translateY(0)'});
      });

      var lastSpark=0;
      document.addEventListener('pointermove',function(e){
        var now=Date.now(); if(now-lastSpark<95)return; lastSpark=now;
        if(Math.random()>.64)return;
        var s=document.createElement('span'); s.className='hw-spark'; s.textContent=Math.random()>.55?'✦':'·';
        s.style.left=e.clientX+'px';s.style.top=e.clientY+'px';
        s.style.setProperty('--sx',((Math.random()-.5)*38)+'px');s.style.setProperty('--sy',(-16-Math.random()*30)+'px');
        document.body.appendChild(s);setTimeout(function(){s.remove()},800);
      },{passive:true});
    }

    document.querySelectorAll('a,button').forEach(function(el){
      el.addEventListener('pointerdown',function(){if(el.classList.contains('fa-magnetic')||el.classList.contains('fa-icon-btn'))el.style.scale='.97'});
      el.addEventListener('pointerup',function(){el.style.scale=''});el.addEventListener('pointercancel',function(){el.style.scale=''})
    });

    var header=document.querySelector('.fa-header__inner');
    if(header){window.addEventListener('scroll',function(){var y=window.scrollY||0;header.style.boxShadow=y>20?'0 20px 60px rgba(0,0,0,.52),0 0 30px rgba(255,139,43,.05)':'0 18px 55px rgba(0,0,0,.42)'},{passive:true})}

    if(!reduceMotion){
      function launchBat(){
        var bat=document.createElement('span');bat.className='hw-flying-bat';bat.setAttribute('aria-hidden','true');bat.textContent='🦇';
        bat.style.top=(10+Math.random()*65)+'vh';bat.style.setProperty('--bat-size',(18+Math.random()*18)+'px');bat.style.setProperty('--bat-speed',(10+Math.random()*7)+'s');
        document.body.appendChild(bat);setTimeout(function(){bat.remove()},18000)
      }
      setTimeout(launchBat,1900);setInterval(launchBat,7200);
    }
  });
})();
